import React from 'react';

import { isDefined, isEmpty } from '@nfctron/nexus-core';

import { TextInput as MantineTextInput } from '@mantine/core';
import { TriangleAlertIcon } from 'lucide-react';

import { type Component, type ComponentDisplayName } from '@root/lib/types/components';

import { type TextInputProps } from './TextInput.types';

/**
 * Returns `error` prop value for given field errors.
 * @export
 */
export const getTextFieldErrorComponent = (message?: React.ReactNode | boolean) =>
	!isEmpty(message) && message !== false ? (
		<span className="flex items-stretch">
			<span className="p-1">
				<TriangleAlertIcon className="size-3 text-sm" />
			</span>
			<span className="flex items-center">
				<span>{message}</span>
			</span>
		</span>
	) : (
		isDefined(message)
	);

/**
 * TextInput component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const TextInput: Component<TextInputProps> = ({ error, ...rest }) => <MantineTextInput error={getTextFieldErrorComponent(error)} {...rest} />;

/**
 * TextInput component display name
 * @type {ComponentDisplayName}
 */
TextInput.displayName = 'component/TextInput';
